import { CardContent } from '@mui/material';
import { CardContentProps } from '@mui/material/CardContent';
import { Theme } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';
import { compose } from 'recompose';

import { WithStyles, withStyles } from '@/hocs/with-styles';

interface Properties extends CardContentProps {}
interface State {}
const styles = (theme: Theme) => ({
  responsive: {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(),
      '&:last-child': {
        paddingBottom: theme.spacing(),
      },
    },
  },
});
class ResponsiveCardContent extends React.Component<Properties & WithStyles<typeof styles>, State> {
  render() {
    const { children, classes, className, ...rest } = this.props;
    return (
      <CardContent {...rest} className={clsx(className, classes.responsive)}>
        {children}
      </CardContent>
    );
  }
}
const enhance = compose<unknown, Properties>(withStyles(styles));
export default enhance(ResponsiveCardContent as React.ComponentType<unknown>);
